import React from "react";
import { Button } from "component-library";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";
import { Logo } from "../components/logo/logo";

type ErrorPageProps = Partial<FallbackProps> & {
  title?: string;
  description?: string;
};

function ErrorPageContent({
  title,
  description,
  resetErrorBoundary,
}: ErrorPageProps) {
  const { t } = useTranslation();

  const handleReload = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    }

    window.location.reload();
  };

  return (
    <div
      style={{
        background:
          "linear-gradient(135deg, #003A73 0%, #357ABD 50%, #0078AB 100%)",
      }}
      className="min-h-screen flex items-center justify-center p-4 relative"
    >
      <Logo variant="light" className="absolute top-4 left-4" />

      <div className="w-full max-w-md bg-white rounded-lg shadow-xl px-6 pt-8 pb-10 text-center">
        <div className="text-2xl font-semibold text-text-primary mb-3">
          {title ?? t("errorPage.title")}
        </div>
        <div className="text-sm text-text-secondary mb-8">
          {description ?? t("errorPage.description")}
        </div>

        <div className="mb-8 p-4 bg-blue-50 border border-blue-100 rounded-md text-sm text-text-secondary">
          {t("errorPage.support")}
        </div>

        <Button
          type="button"
          className="w-full"
          variant="contained"
          onClick={handleReload}
        >
          {t("errorPage.reload")}
        </Button>
      </div>
    </div>
  );
}

export const ErrorPage: React.FC = () => {
  useRouteError();

  return <ErrorPageContent />;
};

export const ErrorFallback: React.FC<FallbackProps> = (props) => {
  return <ErrorPageContent {...props} />;
};
